import { NavigateOptions } from "react-router";

export const DEFAULT_NAVIGATE_OPTIONS: NavigateOptions = {
  replace: true,
  preventScrollReset: true,
};
